"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const getContributionsData = graphql_tag_1.default `
  query($environmentId: String!, $type: String!, $agentId: String) {
    getContributionsData(environmentId: $environmentId, type: $type, agentId: $agentId) {
      id
      environmentId
      type
      agentId
      data
    }
  }
`;
exports.default = getContributionsData;
//# sourceMappingURL=getContributionsData.js.map